/**
 * Sandbox for the gogigi.com event preview iframes. The preview needs scripts and its own origin
 * (postMessage is addressed to that origin and checked against it), and its social links open in
 * a new tab. Everything else stays blocked, such as navigating the promotor app from the frame.
 */
export const PREVIEW_IFRAME_SANDBOX = 'allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox';
